/* PDP "Change Address" bottom sheet (Figma: assets/figma/Change Address Bottom Sheet*.png).
   Replaces the inline "Change" behaviour on the Delivery & Stores block's SAVED state only —
   the first-time empty-state entry still uses the ClickPost input directly (out of scope).

   Reuses existing global plumbing, never duplicates a network call:
   - window.pin_check(pin)        (sections/header.liquid) — manual pincode branch
   - window.callAPI(lat, lon)     (sections/header.liquid) — "Use My Location" branch
   - window.__pdpDeliverySetPin(pin) (assets/pdp-delivery-stores.js) — re-syncs the saved-pin
     display + re-runs the ClickPost EDD lookup for the new pin once persisted
   - store cards refresh themselves: store-locator.js monkey-patches localStorage.setItem so ANY
     same-tab write to 'location_store' already triggers bootstrapPdpNearStoreCards() */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('template-product')) return;

  var LOCATION_API_URL = 'https://gifting.kushals.com/location_api/location.php';
  var normPin = function (v) {
    return String(v || '').replace(/\D/g, '').slice(0, 6);
  };

  // No Confirm button any more (Figma "May 2026 (3)" frames): Check applies the typed pincode
  // directly (spinner inside the Check button while it runs), and "Use My Location" applies as
  // soon as it resolves — both close the sheet themselves.
  var sheet, panel, input, display, displayText, caret, checkBtn, geoBtn, closeBtn, bg;
  var loading = false;
  var pendingKind = ''; // 'check' | 'geo' — which branch is waiting on LOCATION_API_URL

  function build() {
    sheet = document.createElement('div');
    sheet.className = 'pdp-addr-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="pdp-addr-sheet__bg"></div>' +
      '<div class="pdp-addr-sheet__panel" role="dialog" aria-modal="true" aria-label="Select Delivery Address">' +
      '<div class="pdp-addr-sheet__handle"></div>' +
      '<div class="pdp-addr-sheet__head"><h3>Select Delivery Address</h3>' +
      '<button type="button" class="pdp-addr-sheet__close" aria-label="Close">' +
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
      '</button></div>' +
      '<div class="pdp-addr-sheet__row">' +
      '<div class="pdp-addr-sheet__input-wrap">' +
      /* assets/search-normal.svg (Figma-supplied icon) */
      '<svg class="pdp-addr-sheet__search-icon" width="16" height="16" viewBox="0 0 16 16" fill="none">' +
      '<path d="M6.92849 12.2593C9.85429 12.2593 12.2261 9.8875 12.2261 6.96169C12.2261 4.03589 9.85429 1.66406 6.92849 1.66406C4.00269 1.66406 1.63086 4.03589 1.63086 6.96169C1.63086 9.8875 4.00269 12.2593 6.92849 12.2593Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M14.0004 14.8031L11.7754 12.5781" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      /* Round 6: 5 rounds of CSS (autocomplete tokens, readonly, maxlength, !important outline/
         box-shadow) never fully stopped Safari's own native border/highlight painting on the real
         input. Structural fix instead of another CSS guess: the real <input> renders fully
         invisible (opacity:0, see CSS) so nothing native can ever paint visibly on it, and this
         plain, non-form <div> shows the digits — a <div> is not a form field, so no browser has
         any autofill/OTP/focus-ring heuristic that applies to it at all. */
      '<div class="pdp-addr-sheet__display is-empty" aria-hidden="true">' +
      '<span class="pdp-addr-sheet__display-text">Search Pincode</span>' +
      '<span class="pdp-addr-sheet__caret" hidden></span>' +
      '</div>' +
      '<input type="text" inputmode="numeric" name="pdp-addr-query" autocomplete="postal-code" autocorrect="off" spellcheck="false" readonly class="pdp-addr-sheet__input" aria-label="Search Pincode">' +
      '</div>' +
      '<button type="button" class="pdp-addr-sheet__check" disabled><span class="pdp-addr-sheet__check-label">Check</span><span class="pdp-addr-sheet__spinner" hidden></span></button>' +
      '</div>' +
      '<div class="pdp-addr-sheet__divider"><span>Or</span></div>' +
      '<button type="button" class="pdp-addr-sheet__geo">' +
      '<span class="pdp-addr-sheet__geo-label">' +
      /* assets/location-crosshairs 1.svg (Figma-supplied icon) */
      '<svg width="16" height="16" viewBox="0 0 16 16" fill="none">' +
      '<path d="M12.6667 8C12.6667 10.5773 10.5773 12.6667 8 12.6667M12.6667 8C12.6667 5.42267 10.5773 3.33333 8 3.33333M12.6667 8H14M8 12.6667C5.42267 12.6667 3.33333 10.5773 3.33333 8M8 12.6667V14M8 3.33333C5.42267 3.33333 3.33333 5.42267 3.33333 8M8 3.33333V2M3.33333 8H2M10 8C10 9.1046 9.1046 10 8 10C6.8954 10 6 9.1046 6 8C6 6.8954 6.8954 6 8 6C9.1046 6 10 6.8954 10 8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      ' Use My Location</span>' +
      '<span class="pdp-addr-sheet__spinner pdp-addr-sheet__spinner--geo" hidden></span>' +
      '</button>' +
      '</div>';
    document.body.appendChild(sheet);

    panel = sheet.querySelector('.pdp-addr-sheet__panel');
    bg = sheet.querySelector('.pdp-addr-sheet__bg');
    input = sheet.querySelector('.pdp-addr-sheet__input');
    display = sheet.querySelector('.pdp-addr-sheet__display');
    displayText = sheet.querySelector('.pdp-addr-sheet__display-text');
    caret = sheet.querySelector('.pdp-addr-sheet__caret');
    checkBtn = sheet.querySelector('.pdp-addr-sheet__check');
    geoBtn = sheet.querySelector('.pdp-addr-sheet__geo');
    closeBtn = sheet.querySelector('.pdp-addr-sheet__close');

    input.addEventListener('input', function () {
      var digits = normPin(input.value);
      if (input.value !== digits) input.value = digits;
      // `loading ||`: a "Use My Location" lookup in flight must not get its Check re-enabled by typing —
      // the click handler bails on `loading` anyway, which read as "Check does nothing".
      checkBtn.disabled = loading || digits.length !== 6;
      console.log('[KUSHALS-DEBUG] sheet input — value:', JSON.stringify(input.value), 'checkBtn.disabled:', checkBtn.disabled, 'readonly:', input.hasAttribute('readonly'));
      syncDisplay();
    });
    input.addEventListener('focus', function () {
      caret.hidden = false;
    });
    input.addEventListener('blur', function () {
      caret.hidden = true;
    });

    checkBtn.addEventListener('click', onCheck);
    geoBtn.addEventListener('click', onUseMyLocation);
    closeBtn.addEventListener('click', close);
    bg.addEventListener('click', close);

    // Single persistent listener (matches the existing zip.appjetty ajaxComplete pattern in
    // assets/custom.js) rather than a one-off per request.
    if (window.jQuery) {
      jQuery(document).ajaxComplete(function (event, xhr, settings) {
        console.log('[KUSHALS-DEBUG] ajaxComplete — url:', settings && settings.url, 'pendingKind:', pendingKind, 'status:', xhr && xhr.status);
        if (settings.url !== LOCATION_API_URL || !pendingKind) return;
        onLocationApiComplete();
      });
    }
  }

  function syncDisplay() {
    if (input.value) {
      displayText.textContent = input.value;
      display.classList.remove('is-empty');
    } else {
      displayText.textContent = 'Search Pincode';
      display.classList.add('is-empty');
    }
  }

  // target: 'check' (default) or 'geo' — which button's own spinner shows. User: "Only for auto
  // capture location: show the loader on the Use My Location CTA... Currently, the loader is shown
  // on the Check CTA instead." Both buttons now carry their own spinner span; only one shows at a
  // time since only one flow can be loading at once (both onCheck/onUseMyLocation bail on `loading`).
  function setLoading(isLoading, target) {
    loading = isLoading;
    var isGeo = target === 'geo';
    checkBtn.querySelector('.pdp-addr-sheet__spinner').hidden = !(isLoading && !isGeo);
    checkBtn.querySelector('.pdp-addr-sheet__check-label').style.visibility = isLoading && !isGeo ? 'hidden' : 'visible';
    geoBtn.querySelector('.pdp-addr-sheet__spinner--geo').hidden = !(isLoading && isGeo);
    geoBtn.querySelector('.pdp-addr-sheet__geo-label').style.visibility = isLoading && isGeo ? 'hidden' : 'visible';
    input.disabled = isLoading;
    checkBtn.disabled = isLoading || normPin(input.value).length !== 6;
    geoBtn.disabled = isLoading;
  }

  function onLocationApiComplete() {
    if (!pendingKind) return; // ajaxComplete and the poll can both observe the same completion; first one wins
    stopGeoPoll();
    var kind = pendingKind;
    pendingKind = '';
    setLoading(false);
    if (kind === 'geo') {
      // "Use My Location" resolved: sync the pincode display + ClickPost EDD and close — no Confirm
      // step any more.
      var pin = readSavedPin();
      console.log('[KUSHALS-DEBUG] onLocationApiComplete — kind:', kind, 'readSavedPin():', JSON.stringify(pin));
      if (pin) {
        try {
          if (typeof window.__pdpDeliverySetPin === 'function') window.__pdpDeliverySetPin(pin);
        } catch (e) {
          console.log('[KUSHALS-DEBUG] onLocationApiComplete — __pdpDeliverySetPin THREW:', e);
        }
        close();
      } else if (window.KToast) {
        KToast.error('Could not detect your location. Please try again.');
      }
      return;
    }
    // 'check' branch: pin_check() already persisted location_store/pin on success.
    var checkedPin = normPin(input.value);
    if (typeof window.__pdpDeliverySetPin === 'function') window.__pdpDeliverySetPin(checkedPin);
    close();
  }

  // Fallback completion for the "Use My Location" branch. The primary signal is jQuery's global
  // ajaxComplete (settings.url === LOCATION_API_URL); if that never fires for any reason, `loading`
  // stayed true for the rest of the sheet session and BOTH Check and Confirm were dead. callAPI()'s
  // success handler always writes localStorage 'location_store', so a change in that raw value is
  // an equally valid "done" signal — polled every 300ms, hard stop at 15s.
  var geoPollTimer = null;
  var geoPollDeadline = 0;
  function readRawLocation() {
    try {
      return window.KushalsStorageTTL ? window.KushalsStorageTTL.get('location_store') : localStorage.getItem('location_store');
    } catch (e) {
      return null;
    }
  }
  function stopGeoPoll() {
    if (geoPollTimer) {
      clearInterval(geoPollTimer);
      geoPollTimer = null;
    }
  }
  function startGeoPoll(prevRaw) {
    stopGeoPoll();
    geoPollDeadline = Date.now() + 15000;
    geoPollTimer = setInterval(function () {
      if (pendingKind !== 'geo') {
        stopGeoPoll();
        return;
      }
      var raw = readRawLocation();
      if (raw && raw !== prevRaw) {
        console.log('[KUSHALS-DEBUG] geo poll — location_store changed, resolving without ajaxComplete');
        onLocationApiComplete();
        return;
      }
      if (Date.now() > geoPollDeadline) {
        console.log('[KUSHALS-DEBUG] geo poll — timed out after 15s, releasing loading state');
        stopGeoPoll();
        pendingKind = '';
        setLoading(false);
        if (window.KToast) KToast.error('Unable to detect location.');
      }
    }, 300);
  }

  function readSavedPin() {
    try {
      var raw = window.KushalsStorageTTL ? window.KushalsStorageTTL.get('location_store') : localStorage.getItem('location_store');
      var parsed = JSON.parse(raw || 'null');
      return normPin(parsed && parsed.postal);
    } catch (e) {
      return '';
    }
  }

  // Check = apply the typed pincode directly (was: Check only validated, Confirm applied).
  function onCheck() {
    if (checkBtn.disabled || loading) return;
    if (normPin(input.value).length !== 6) return;
    pendingKind = 'check';
    setLoading(true);
    if (typeof window.pin_check === 'function') window.pin_check(normPin(input.value));
  }

  function onUseMyLocation() {
    if (loading) return;
    if (!navigator.geolocation) {
      if (window.KToast) KToast.error('Location is not supported on this device.');
      return;
    }
    setLoading(true, 'geo');
    console.log('[KUSHALS-DEBUG] onUseMyLocation — requesting geolocation; callAPI is', typeof window.callAPI);
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        pendingKind = 'geo';
        console.log('[KUSHALS-DEBUG] onUseMyLocation — geo OK:', pos.coords.latitude, pos.coords.longitude);
        if (typeof window.callAPI === 'function') {
          var prevRaw = readRawLocation();
          window.callAPI(pos.coords.latitude, pos.coords.longitude);
          startGeoPoll(prevRaw);
        } else {
          pendingKind = '';
          setLoading(false);
        }
      },
      function (err) {
        console.log('[KUSHALS-DEBUG] onUseMyLocation — geo ERROR code:', err && err.code, err && err.message);
        setLoading(false);
        if (window.KToast) {
          KToast.error(
            err.code === err.PERMISSION_DENIED
              ? 'Please enable location access to auto-detect.'
              : 'Unable to detect location.'
          );
        }
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    );
  }

  // iOS Safari-only: the field sits `readonly` until the user's own tap/click drops it, so
  // Safari's AutoFill / "suggest strong password" heuristic never gets to look at it and paint
  // the blue tint + black ring (this is what round 2's `autocomplete="new-password"` accidentally
  // triggered on iOS Safari specifically — that token tells Safari "this is a password field", so
  // it offered/highlighted a suggested password even on this numeric input). Re-armed on every
  // open() since removing `readonly` is permanent and the {once:true} listeners consume themselves.
  function armReadonlyGuard() {
    input.setAttribute('readonly', 'readonly');
    var dropReadonly = function () {
      input.removeAttribute('readonly');
    };
    input.addEventListener('touchstart', dropReadonly, { once: true, passive: true });
    input.addEventListener('mousedown', dropReadonly, { once: true });
  }

  // iOS: `.pdp-addr-sheet` is `position:fixed; inset:0`, which pins to the full LAYOUT viewport,
  // not the visible area above the keyboard. Without this, the sheet's bottom content (Check,
  // Use My Location) ends up under the keyboard and the user has to manually scroll the page.
  function syncViewport() {
    if (!window.visualViewport || !sheet) return;
    sheet.style.height = window.visualViewport.height + 'px';
    sheet.style.top = window.visualViewport.offsetTop + 'px';
  }

  function open() {
    if (!sheet) build();
    pendingKind = '';
    stopGeoPoll();
    setLoading(false);
    input.value = '';
    syncDisplay();
    armReadonlyGuard();
    checkBtn.disabled = true;
    sheet.hidden = false;
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
    });
    window.themeScrollLock && window.themeScrollLock.lock();
    syncViewport();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', syncViewport);
      window.visualViewport.addEventListener('scroll', syncViewport);
    }
    try {
      input.focus();
    } catch (e) {}
  }

  function close() {
    if (!sheet) return;
    sheet.classList.remove('is-open');
    window.themeScrollLock && window.themeScrollLock.unlock();
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', syncViewport);
      window.visualViewport.removeEventListener('scroll', syncViewport);
    }
    sheet.style.height = '';
    sheet.style.top = '';
    setTimeout(function () {
      sheet.hidden = true;
    }, 250);
  }

  // Capture-phase, ahead of the bubble-phase showEntry() listener already bound to this button
  // in pdp-delivery-stores.js — stops it from reaching that listener at all, so nothing needs to
  // change there. The inline ClickPost input for the very first (never-saved) entry is untouched.
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest('.pdp-ds-change');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      open();
    },
    true
  );
})();
